export default "__VITE_ASSET__CpKF$z9n__"